namespace app {
    class AccountInvoiceListController {
        constructor(private invoices: IInvoice[]) {}
    }
    angular.module("app").controller("AccountInvoiceListController", AccountInvoiceListController);
}